import { render } from "./Menu.vue?vue&type=template&id=5eaffd46"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\guada\\OneDrive\\Documents\\GitHub\\simulador-tweets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__